import { Navigate } from 'react-router'
import { routes } from '@/routes'

function LuxeSubmissionsQueueRoute() {
	return (
		<Navigate
			replace
			to={routes.LUXE_SUBMISSIONS_QUEUE_VISUAL_VETTING.handle.fullPath}
		/>
	)
}

export { LuxeSubmissionsQueueRoute }
